import {CompetitorResultsDetail, FINISH_CONTROL_POINT_TYPE, Race, ResultProcessingType} from "@model";

///returns distance in meters
export function getCompetitorDistance(competitorResultsDetail?: CompetitorResultsDetail, race?: Race): number | undefined {
    if (!competitorResultsDetail || !race) {
        return undefined;
    }
    let distance: number | undefined = competitorResultsDetail.distance;
    if (!distance) {
        const ltp = competitorResultsDetail.ltpCompetitorStageDetail;

        if (ltp?.tp === FINISH_CONTROL_POINT_TYPE && race.length) {
            distance = race.length  * 1000;
        } else if (ltp?.distanceFromStart) {
            distance = ltp.distanceFromStart;
        } else if (competitorResultsDetail.SGS){
            const sgsFinishItem = Object.values(competitorResultsDetail.SGS).filter((item) => item.tp !== FINISH_CONTROL_POINT_TYPE)
            if (sgsFinishItem && race.length) {
                distance = race.length * 1000;
            }
        }
    }
    if (competitorResultsDetail?.laps && race.raceSettings?.resultProcessingType !== ResultProcessingType.TIME_LIMITED) {
        if (!distance && race.length) {
            distance = race.length * 1000;
        }
        if (distance) {
            return (distance*(Object.keys(competitorResultsDetail.laps).length));
        }
    }
    return distance;
}